import React from "react";
import { useSearchParams } from "react-router-dom";
import ProductListing from "@/components/product/ProductListing";
import { useI18n } from "@/i18n/I18nProvider";

export default function SearchPage() {
  const [params] = useSearchParams();
  const q = params.get("q") || "";
  const sort = params.get("sort");
  const { t } = useI18n();
  const base = q ? { search: q } : sort ? {} : {};
  return <ProductListing title={q ? `${t("results")}: "${q}"` : t("best_sellers")} baseParams={base} />;
}
